var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    priceValue,
    priceDisplayValue,
    checkValue
  } = options;

__p+='\n';
 let selectedClass = ""; 
__p+='\n';
 if(MOVE.DataStore.getData("ab_facets") == "V1") {
__p+='\n';
  if(checkValue == priceValue && (checkValue != undefined || priceValue != "Any")){ 
__p+='\n  ';
 selectedClass = 'selected-facet-color' 
__p+='\n';
 } 
__p+='\n';
 } 
__p+='\n<li data-val="'+
((__t=( priceValue ))==null?'':__t)+
'" class="'+
((__t=( selectedClass ))==null?'':__t)+
'">'+
((__t=( priceDisplayValue ))==null?'':__t)+
'</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/price_facet_list_item.jst.ejs